import React from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import { FormProvider, Controller } from "react-hook-form";
import { ChevronBigLeft } from "@tiny/icons";
import useAssignToTagForm from "./AssignToTagForm.hooks";
import TagSelector from "./TagSelector/TagSelector";

interface AssignToTagFormProps {
  id: string;
}

const AssignToTagForm: React.FC<AssignToTagFormProps> = ({ id }) => {
  const {
    methods,
    control,
    onSubmit,
    handleCancel,
    saveDisabled,
    viewMode,
    tags,
    isLoadingTags,
  } = useAssignToTagForm({ id });

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit} style={{ height: "100%" }}>
        <Box
          sx={{
            py: 4,
            px: 6,
            display: "flex",
            flexDirection: "column",
            width: { xs: "320px", xl: "20vw" },
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          {/* Header */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton sx={{ px: 0 }} onClick={handleCancel}>
              <ChevronBigLeft color="success" />
            </IconButton>
            <Typography variant="h2">Add a Tag</Typography>
          </Box>

          {/* Form Content */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              mt: 6,
              flex: 1,
            }}
          >
            <Controller
              name="tags"
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <TagSelector
                  value={value || []}
                  onChange={onChange}
                  options={tags}
                  placeholder="Search or type to add new tags"
                  label="Tags"
                />
              )}
            />
          </Box>

          {/* Footer Buttons */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              p: 2,
            }}
          >
            <Button onClick={handleCancel}>Cancel</Button>
            <Button
              variant="contained"
              type="submit"
              disabled={saveDisabled || viewMode}
            >
              Save
            </Button>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default AssignToTagForm;
